"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isEMMiLocalizedText = exports.EmmiErrorCode = exports.EMMiAssetPropertyFieldType = void 0;
var EMMiAssetPropertyFieldType;
(function (EMMiAssetPropertyFieldType) {
    EMMiAssetPropertyFieldType["Text"] = "Text";
    EMMiAssetPropertyFieldType["MultiLineText"] = "MultiLineText";
    EMMiAssetPropertyFieldType["Radio"] = "Radio";
    EMMiAssetPropertyFieldType["Boolean"] = "Boolean";
    EMMiAssetPropertyFieldType["MultiSelectList"] = "MultiSelectList";
    EMMiAssetPropertyFieldType["DropDown"] = "DropDown";
    EMMiAssetPropertyFieldType["DateTime"] = "DateTime";
    EMMiAssetPropertyFieldType["Date"] = "Date";
    EMMiAssetPropertyFieldType["Time"] = "Time";
    EMMiAssetPropertyFieldType["Number"] = "Number";
    EMMiAssetPropertyFieldType["CheckBox"] = "CheckBox";
})(EMMiAssetPropertyFieldType = exports.EMMiAssetPropertyFieldType || (exports.EMMiAssetPropertyFieldType = {}));
/** Error codes from integrations-api for emmi errors for informative error display in UI */
var EmmiErrorCode;
(function (EmmiErrorCode) {
    EmmiErrorCode["customerMissingIntegrationCredentials"] = "customerMissingIntegrationCredentials";
    EmmiErrorCode["loginFailed"] = "loginFailed";
    EmmiErrorCode["getFolderByIdFailed"] = "getFolderByIdFailed";
    EmmiErrorCode["getFoldersFailed"] = "getFoldersFailed";
    EmmiErrorCode["getAssetsFromFolderFailed"] = "getAssetsFromFolderFailed";
    EmmiErrorCode["deleteExpiredContentFailed"] = "deleteExpiredContentFailed";
    EmmiErrorCode["propertyValuesMissingFromAsset"] = "propertyValuesMissingFromAsset";
    EmmiErrorCode["screenTypeMissingFromAsset"] = "screenTypeMissingFromAsset";
    EmmiErrorCode["invalidFolder"] = "invalidFolder";
    EmmiErrorCode["invalidFolderStartEndDate"] = "invalidFolderStartEndDate";
    /** For example, when API Gateway timeouts from client side  */
    EmmiErrorCode["importFolderFailed"] = "importFolderFailed";
})(EmmiErrorCode = exports.EmmiErrorCode || (exports.EmmiErrorCode = {}));
exports.isEMMiLocalizedText = (value) => typeof (value === null || value === void 0 ? void 0 : value['x-default']) === 'string';
//# sourceMappingURL=emmi.js.map